<template>
  <div id="contacts" class="v2-footer">
    <div class="v2-container d-flex">
      ©{{ new Date().getFullYear() }}
      <div class="v2-footer-contacts">
        <a
          href="mailto:larisaangald@gmail.com"
          target="_blank"
          class="v2-footer-contacts__link"
          data-type="mail"
        ></a>
        <a
          href="https://t.me/Larissa_Angald"
          target="_blank"
          class="v2-footer-contacts__link"
          data-type="tg"
        ></a>
        <a
          href="https://github.com/langald"
          target="_blank"
          class="v2-footer-contacts__link"
          data-type="github"
        ></a>
        <a
          href="https://www.instagram.com/larissa_angald/"
          target="_blank"
          class="v2-footer-contacts__link"
          data-type="insta"
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "V2Footer",
  data() {
    return {};
  },
};
</script>
